import React, {useEffect, useState} from "react";

import ActsService from "../../services/acts.service";
import {Breadcrumb, Button, Card, Col, Form, Row} from "react-bootstrap";
import ActItem from "./actItem.component";
import Container from "react-bootstrap/Container";
import AuthService from "../../services/auth.service";
import {GENRES, isLoggedIn} from "../../common/utils";
import InputWithIcon from "../../common/input-with-icon";
import {API_EDITS_ALLOWED} from "../../services/axios.utils";

const ActsList = () => {
    const [search, setSearch] = useState("")
    const [acts, setActs] = useState([])
    const [actsCount, setActsCount] = useState(0)
    const [actType, setActType] = useState("")
    const [slot, setSlot] = useState("")
    const [scheduled, setScheduled] = useState("")

    let user = AuthService.getCurrentUser();
    let loggedIn = isLoggedIn();
    let editsAllowed = API_EDITS_ALLOWED === "true" || (loggedIn && user.is_admin);

    const fetchActs = () => {
        ActsService.getActs(search, actType, slot, scheduled).then(
            response => {
                // this is a hack - we are filtering scheduled on the front end
                let filtered = [];
                response.data.data.forEach(a => {
                    if (scheduled === "") {
                        filtered.push(a);
                    } else if (scheduled === "true" && a.scheduled_venue_slots.length > 0) {
                        filtered.push(a);
                    } else if (scheduled === "false" && a.scheduled_venue_slots.length === 0) {
                        filtered.push(a);
                    }
                })
                setActs(filtered);
                setActsCount(filtered.length);
                console.log("acts:" + JSON.stringify(filtered));
            },
            error => {
                console.log(error);
            });
    }

    // load once on mount or on filter changes
    useEffect(() => {
        fetchActs();
    }, [actType, slot, scheduled]);  // eslint-disable-line react-hooks/exhaustive-deps

    // fetch acts with search filter after debounce
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            fetchActs();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [search]);  // eslint-disable-line react-hooks/exhaustive-deps

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const handleActTypeChange = (e) => {
        setActType(e.target.value);
    };

    const handleSlotChange = (e) => {
        setSlot(e.target.value);
    };

    const handleScheduledChange = (e) => {
        setScheduled(e.target.value);
    };

    const anySearch = () => {
        return search !== null || actType !== null || slot !== null || scheduled !== null;
    }

    return (
        <Container fluid>
            <Row>
                <Col>
                    <h3>
                        <Breadcrumb>
                            <Breadcrumb.Item active>Acts</Breadcrumb.Item>
                        </Breadcrumb>
                    </h3>
                </Col>
                <Col>
                    <div className="float-end">
                        {(user !== null && (user.is_performer || user.is_admin)) &&
                            <Button href="/acts/new" disabled={!editsAllowed}>New Act</Button>
                        }
                    </div>
                </Col>
            </Row>
            {/*<Row className="mb-3">*/}
            {/*    <Col>*/}
            {/*        <Alert variant="primary">*/}
            {/*            <PastPFDateAndDesc/>*/}
            {/*        </Alert>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            {/*{loggedInHost &&*/}
                            {/*    <Alert>*/}
                            {/*        <div>*/}
                            {/*            If you're a venue owner looking to host one or more acts, use the search fields*/}
                            {/*            below to find acts based on name or description, genre, preferred slots, and*/}
                            {/*            status. Once you find an act you like, click on it and fill out the contact*/}
                            {/*            form at the bottom to let the owner know you are interested in a match.*/}
                            {/*        </div>*/}
                            {/*    </Alert>*/}
                            {/*}*/}
                            <Container style={{paddingLeft: "0px", paddingRight: "0px"}}>
                                <Row className="mb-3">
                                    <Col>Found {actsCount} results</Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col>
                                        <InputWithIcon
                                            type="text"
                                            value={search}
                                            placeholder="Search by name or description"
                                            onChange={handleSearchChange}
                                            icon="bi-search"
                                        />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col xs={2}>
                                        Filter
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Select onChange={handleActTypeChange}>
                                            <option value="">Any Genre</option>
                                            {GENRES.map((g, index) => (
                                                <option key={index} value={g.value}>{g.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Select onChange={handleSlotChange}>
                                            <option value="">Any Slot</option>
                                            <option value="Slot 1">Slot 1</option>
                                            <option value="Slot 2">Slot 2</option>
                                            <option value="Slot 3">Slot 3</option>
                                            <option value="Slot 4">Slot 4</option>
                                            <option value="Slot 5">Slot 5</option>
                                        </Form.Select>
                                    </Col>
                                    <Col xs={4}>
                                        <Form.Select onChange={handleScheduledChange}>
                                            <option value="">Any Status</option>
                                            <option value="false">Looking for a host</option>
                                            <option value="true">Scheduled with a host</option>
                                        </Form.Select>
                                    </Col>
                                </Row>
                            </Container>
                        </Card.Body>
                    </Card>

                    {acts.length === 0 && anySearch() &&
                        <>
                            There are no acts that match your search criteria.
                        </>
                    }
                    {acts.length === 0 && !anySearch() &&
                        <>
                            There are no registered acts yet. Please check again later.
                        </>
                    }
                    {acts.length > 0 &&
                        acts.map((act) =>
                            <ActItem key={act.id} act={act}/>
                        )
                    }
                </Col>
            </Row>
        </Container>
    );
};

export default ActsList;
